import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
export default {
  name: 'd2-table',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    }
  },
  render: function render(createElement) {
    var propsDefault = {
      stripe: true,
      height: '100%',
      rowKey: 'id',
      treeProps: {
        children: 'children_list'
      }
    };
    return createElement('el-table', {
      ref: 'table',
      props: Object.assign(propsDefault, this.$attrs),
      on: this.$listeners,
      directives: [{
        name: 'loading',
        value: this.$attrs.loading || false
      }]
    }, this.columns.map(function (column) {
      var scopedSlots = column.render ? {
        scopedSlots: {
          default: function _default(scope) {
            return column.render(scope);
          }
        }
      } : null;
      return createElement('el-table-column', _objectSpread({
        props: column
      }, scopedSlots || {}));
    }));
  },
  watch: {
    columns: function columns() {
      this.$nextTick(this.$refs.table.doLayout);
    }
  },
  methods: {
    // https://element.eleme.cn/#/zh-CN/component/table#table-methods
    method: function method(methodName) {
      var fn = this.$refs.table[methodName];

      if (fn) {
        for (var _len = arguments.length, arg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          arg[_key - 1] = arguments[_key];
        }

        fn.apply(void 0, arg);
      }
    }
  }
};